<style>
#HistoryChangesModal .v--modal-box.v--modal {
  min-width: 410px !important;
  min-height: 300px !important;
}
#HistoryChangesModal *:not(.v-icon) {
  font-size: 12px;
}
#HistoryChangesModal .modal__footer {
  display: none;
}
</style>

<template>
  <div class="wrapper">
    <Modal
      modalName="HistoryChangesModal"
      title="Historia zmian"
      :buttons="['']"
    >
      <HistoryChangesTable />
    </Modal>
  </div>
</template>

<script>
import Modal from "../../../shared/Modal";
import HistoryChangesTable from "../../table/history/HistoryChangesTable";

export default {
  components: {
    Modal,
    HistoryChangesTable
  },
  data: () => ({}),
  methods: {}
};
</script>


// WEBPACK FOOTER //
// src/components/viewer/settings/modals/HistoryChanges.vue